/** Page size for collection products (API limit and client-side pagination). */
export var COLLECTION_PAGE_SIZE = 150;
/** Max collection IDs per GraphQL request when fetching multiple collections. Shopify nodes(ids) allows up to 250; use 250 so 45 collections = 1 request instead of many. */
export var COLLECTION_IDS_CHUNK_SIZE = 10;
/** Max concurrent requests when fetching remaining pages across collections (higher = faster load, stay under Storefront API rate limits). */
export var COLLECTION_PAGINATION_CONCURRENCY = 12;
export var EDIT_ORDER_FLAG = "editOrder";
export var INVENTORY_MANAGEMENT_SHOPIFY = "shopify";
export var INVENTORY_POLICY_DENY = "deny";
export var REDIRECT_TAB_FLAG = "redirectTab";
export var APPLY_SHIPPING_COST_YES = "Yes";
export var APPLY_SHIPPING_COST_NO = "No";
export var CREATE_ORDER_TYPE = "createOrder";
export var DRAFT_ORDER = "draftOrder";
export var CREATE_CHECKOUT = "CREATE_CHECKOUT";
export var SELECT_SHIPPING_AT_CHECKOUT = "SelectShippingAtCheckout";
export var IS_SHIPPING_ADDRESS = "isShippingAddress";
export var IS_BILLING_ADDRESS = "isBillingAddress";
export var DEFAULT_FONT_FAMILY = "Inter";
export var DEFAULT_BACKGROUND_COLOR = "#E5E5E5";
export var DEFAULT_PRIMARY_COLOR = "#303030";
export var TOASTER_TIMEOUT = 5000;
export var PaymentTermType;
(function (PaymentTermType) {
    PaymentTermType["RECEIPT"] = "RECEIPT";
    PaymentTermType["FULFILLMENT"] = "FULFILLMENT";
    PaymentTermType["NET"] = "NET";
    PaymentTermType["FIXED"] = "FIXED";
    PaymentTermType["UNKNOWN"] = "UNKNOWN";
})(PaymentTermType || (PaymentTermType = {}));
export var OrderRowDetailKind;
(function (OrderRowDetailKind) {
    OrderRowDetailKind["Standard"] = "standard";
    OrderRowDetailKind["Draft"] = "draft";
    OrderRowDetailKind["Refund"] = "refund";
})(OrderRowDetailKind || (OrderRowDetailKind = {}));
export var StandardOrderMoreActionsMode;
(function (StandardOrderMoreActionsMode) {
    StandardOrderMoreActionsMode["Paid"] = "paid";
    StandardOrderMoreActionsMode["Unpaid"] = "unpaid";
    StandardOrderMoreActionsMode["None"] = "none";
})(StandardOrderMoreActionsMode || (StandardOrderMoreActionsMode = {}));
export var StandardMobileLineItemsVariant;
(function (StandardMobileLineItemsVariant) {
    StandardMobileLineItemsVariant["YourSales"] = "yourSales";
    StandardMobileLineItemsVariant["Pending"] = "pending";
})(StandardMobileLineItemsVariant || (StandardMobileLineItemsVariant = {}));
export var ALL_ORDERS_ROW_REFUND_FINANCIAL_STATUSES = ["refunded", "partially_refunded"];
export var ALL_ORDERS_ROW_PAID_LIKE_STATUSES = ["paid", "completed", "partially_refunded"];
export var ALL_ORDERS_ROW_DRAFT_LIKE_STATUSES = ["open", "voided"];
/** Invoice checkout redirect: append `skip_shop_pay` only for this Shopify shop domain. */
export var SHOP_CHECKOUT_SKIP_SHOP_PAY_DOMAIN = "kylinaustralia.myshopify.com";
